import {
  INSTALLATION_GUIDE_URL,
  INSTALLATION_GUIDE_LABEL,
  PRODUCTS_WITH_OPT,
  HPE_SIMPLIVITY,
  FLASH_OPT_GREEN,
  FLASH_OPT_BROWN,
  NEW_ESXI_CLUSTER,
  MODEL_LIST_PCBE,
} from '../constants';
import i18n from '../i18n';

export const getDownloadInstallationGuideUrl = ({
  productName,
  pageOpt,
  simplivitymodel,
  hpeAlletraDHCImodel,
  arrayModel,
}) => {
  let downloadFullDocLabel = INSTALLATION_GUIDE_LABEL[productName];
  let downloadFullDocUrl = INSTALLATION_GUIDE_URL[productName];
  if (typeof downloadFullDocUrl === 'object') {
    if (arrayModel === HPE_SIMPLIVITY) {
      downloadFullDocLabel = i18n.t('downloadDeploymentGuideSimplivity');
      downloadFullDocUrl = downloadFullDocUrl[simplivitymodel];
    } else {
      if (MODEL_LIST_PCBE.includes(arrayModel)) {
        downloadFullDocUrl =
          hpeAlletraDHCImodel === NEW_ESXI_CLUSTER
            ? downloadFullDocUrl[FLASH_OPT_GREEN]
            : downloadFullDocUrl[FLASH_OPT_BROWN];
      } else {
        downloadFullDocUrl = downloadFullDocUrl[pageOpt];
      }
    }
  }
  return { downloadFullDocUrl, downloadFullDocLabel };
};

export const replaceMarkdownLink = (mdString) => {
  //check for links [text](url)
  let elements = ('' + mdString).match(/\[.*?\)/g);
  if (elements !== null && elements.length > 0) {
    for (const el of elements) {
      let url = el.match(/\((.*?)\)/)[1]; //get only the link
      let txt = el.match(/\[(.*?)\]/)[1]; //get only the txt

      // TODO: remove if condition after we support HTML version
      const myReg = /\.(image)|(png)/i;
      if (!myReg.test(txt) && !myReg.test(url)) {
        txt = txt.replace(/^.*:\/\//i, '');
        mdString = mdString.replace(
          el,
          // '<a href="' + url + '" target="_blank" rel="noopener noreferrer" data-test-id="doc-download-link">' + txt + '</a>',
          `<a href="${url}" target="_blank" rel="noopener noreferrer" data-test-id="doc-download-link">${txt}</a>`,
        );
      }
    }
  }
  return mdString;
};

export const getPageContentReducerKey = ({
  pageName,
  model,
  pageOpt,
  platform,
}) => {
  let key = model && model.length > 0 ? `${pageName}_${model}` : pageName;
  if (pageOpt && pageOpt.length > 0) {
    key = `${key}_${pageOpt}`;
  }
  if (platform && platform.length > 0) {
    key = `${key}_${platform}`;
  }
  return key;
};

export const getPageOptValue = ({ productId, queryStringValues }) => {
  const pageOpt = queryStringValues['opt'];
  return PRODUCTS_WITH_OPT.includes(productId) ? pageOpt : '';
};
